<template>
    <v-dialog persistent v-model="dialog" width=50%>
        <v-card class="px-2" height="775px">
            <v-card-title>Select host as ambassador</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-row no-gutters>
                    <v-col cols="6" class="pr-2">
                        <v-text-field v-model="search" clearable prepend-icon="mdi-magnify" label="Search name" single-line hide-detail/>
                    </v-col>
                    <v-col cols="6" class="pl-2">
                        <v-text-field v-model="ambassador_name" readonly label="Current ambassador"></v-text-field>
                    </v-col>
                    <!-- <v-col cols="6">
                        <v-checkbox v-model="active" label="Active only" @change="filterSelect"></v-checkbox>
                    </v-col> -->
                </v-row> 
                <div class="scrollable">
                    <v-row  dense>
                        <v-col cols="12">
                            <v-data-table 
                                v-model="selected_hosts"
                                dense 
                                show-select
                                single-select
                                return-object
                                :footer-props="{
                                    'items-per-page-options': [10, 15, 50, -1]
                                }"
                                :items-per-page="15"
                                :headers="getHeaders()" 
                                :search="search"
                                :items="all_hosts"
                                item-key="eign_code">
                            </v-data-table>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
        <!-- </v-card>
        <v-card> -->
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small v-on:click="saveSelect">Save</v-btn>
                <v-btn color="primary" small v-on:click="closeSelect">Cancel</v-btn> 
            </v-card-actions> 
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
        },             
        data() {
            return {
                dialog: false,
                ambassador: "",
                ambassador_name: "",
                search: "",
                all_hosts: [],
                // filter_hosts: [],
                selected_hosts: [],
            }
        },
        methods: {  
            getAmbassadors() {
                this.$axios.post("ares/json/ares/eign/getAmbassadors.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getAmbassadors"
                    },
                    getAmbassadors: {
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.dialog = false;
                    } else {
                        this.all_hosts = res.data.getAmbassadors;

                        this.selected_hosts = [];
                        for (let i = 0; i < this.all_hosts.length; i++) {
                            if (this.all_hosts[i].eign_code === this.ambassador) {
                                this.selected_hosts.push(this.all_hosts[i]);  
                            }           
                        }
                        // this.filterSelect();
                        this.dialog = true;
                    }
                });
            },    
            openSelect(ambassador, name) {
                this.ambassador = ambassador;
                if (name === "") {
                    this.ambassador_name = "No ambassador";
                } else {
                    this.ambassador_name = name;
                }
                // Clear previous values
                this.search = "";
                this.all_hosts = [];
                this.selected_hosts = [];
                this.getAmbassadors();
            },
            saveSelect() {
                let ambassador = "";
                let naam = "";
                for (let i = 0; i < this.selected_hosts.length; i++) {
                    ambassador = this.selected_hosts[i].eign_code;
                    naam = this.selected_hosts[i].eign_naam;
                }
                this.$emit("actionClick", ambassador, naam);
                this.dialog = false;
            },
            closeSelect() {
                this.dialog = false;
            },
            getHeaders() {
                return [
                    { text: "Host", value: "eign_code", sortable: true},
                    { text: "Name", value: "eign_naam", sortable: false},
                    // { text: "Actief", value: "gebr_actief", sortable: false},
                ];
            },
            // filterSelect() {
            //     if (this.active) {
            //         this.filter_users = [];
            //         for (let i = 0; i < this.all_hosts.length; i++) {
            //             if (this.all_hosts[i].gebr_actief) {
            //                 this.filter_users.push(this.all_hosts[i]);  
            //             }           
            //         }                   
            //     } else {
            //         this.filter_users = this.all_hosts;
            //     }
            // },            
        },
    }
</script>

<style scoped>
    .scrollable {
        max-height: 575px;
        overflow-x: hidden;
        overflow-y: auto;
    }
</style>